import { render } from "./StudentPromotion.vue?vue&type=template&id=5dc3bdea&scoped=true"
import script from "./StudentPromotion.vue?vue&type=script&lang=js"
export * from "./StudentPromotion.vue?vue&type=script&lang=js"

import "./StudentPromotion.vue?vue&type=style&index=0&id=5dc3bdea&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc3bdea"]])

export default __exports__